<template>
  <aside id="app-drawer">
    <nav id="overview-nav">
      <ul :class="{ 'active-menu' : configMenu }">
        <li @click="toggleMenu('configMenu')" v-ripple class="sub-menu-toggle"><img src="../assets/img/icons/items/funktionen.svg" alt="Konfigurieren" /><span>Konfigurieren</span></li>
        <transition name="slide" mode="out-in">
          <ul v-if="configMenu">
            <li><router-link v-ripple to="/" :class="linkClasses" @click.native="menuItemClicked()">Start</router-link></li>
            <li><router-link v-ripple to="/templates" :class="linkClasses" @click.native="menuItemClicked()">Templates</router-link></li>
            <li><router-link v-ripple to="/sprachen" :class="linkClasses" @click.native="menuItemClicked()">Sprachen</router-link></li>
            <li><router-link v-ripple to="/plugins" :class="linkClasses" @click.native="menuItemClicked()">Plug-ins</router-link></li>
            <transition name="expand" mode="out-in">
              <li v-if="blogfunktionActive"><router-link v-ripple to="/blog" :class="linkClasses" @click.native="menuItemClicked()">Blog-Funktionen</router-link></li>
            </transition>
            <transition name="expand" mode="out-in">
              <li v-if="shopfunktionActive"><router-link v-ripple to="/shop" :class="linkClasses" @click.native="menuItemClicked()">Shop-Funktionen</router-link></li>
            </transition>
            <li><router-link v-ripple to="/technisches" :class="linkClasses" @click.native="menuItemClicked()">Technisches</router-link></li>
            <li><router-link v-ripple to="/services" :class="linkClasses" @click.native="menuItemClicked()">Services</router-link></li>
            <li><router-link v-ripple to="/zusammenfassung" :class="linkClasses" @click.native="menuItemClicked()">Kurzübersicht</router-link></li>
          </ul>
        </transition>
      </ul>
      <ul :class="{ 'active-menu' : profileMenu }">
        <li @click="toggleMenu('profileMenu')" v-ripple class="sub-menu-toggle"><img src="../assets/img/icons/items/basics.svg" alt="Profil" /><span>Ihr Profil</span></li>
        <transition name="slide" mode="out-in">
          <ul v-if="profileMenu">
            <li><router-link v-ripple to="/account" :class="linkClasses" @click.native="menuItemClicked()">Account</router-link></li>
            <li><router-link v-ripple to="/projekte" :class="linkClasses" @click.native="menuItemClicked()">Projekte</router-link></li>
          </ul>
        </transition>
      </ul>
    </nav>
    <button v-if="loggedIn" @click="signOut()" class="logout-button">Ausloggen</button>
    <nav id="sub-nav">
      <ul>
        <li><a href="https://about.clickzip.de/" target="_blank">Über clickzip</a></li>
        <li><a href="https://clickzip.de/agb.pdf" target="_blank">AGB</a></li>
        <li><a href="https://about.clickzip.de/impressum/" target="_blank">Impressum</a></li>
        <li><a href="https://about.clickzip.de/datenschutzerklaerung/" target="_blank">Datenschutz</a></li>
      </ul>
    </nav>
    <span id="legal-notice">&copy; 2020 clickzip<br>Alle Rechte vorbehalten.<br>Der Konfigurator gibt eine unverbindliche Schätzung des Preises der von Ihnen konfigurierten Website an und stellt kein Angebot dar.</span>
  </aside>
</template>

<script>

export default {
  name: 'Overview',
  props: {
    windowWidth: {
      type: Number
    }
  },
  data: function () {
    return {
      configMenu: true,
      profileMenu: false,
      linkClasses: 'rpl rpl-dark flex-container flex-row align-items-center page-controller needsclick'
    }
  },
  computed: {
    loggedIn: function () {
      return this.$root.loggedIn
    },
    currentRouteName: function () {
      return this.$route.name
    },
    blogfunktionActive: function () {
      if (this.$root.items.find(item => item.id === 'blogfunktion').status) {
        return true
      } else {
        return false
      }
    },
    shopfunktionActive: function () {
      if (this.$root.items.find(item => item.id === 'onlineshop').status) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    signOut: function () {
      this.$root.signOut()
    },
    toggleMenu: function (subMenu) {
      if (subMenu === 'configMenu') {
        if (this.windowWidth >= 1180) {
          this.$router.push('/')
        }
        this.configMenu = true
        this.profileMenu = false
      } else {
        if (this.windowWidth >= 1180) {
          this.$router.push('/account')
        }
        this.configMenu = false
        this.profileMenu = true
      }
    },
    menuItemClicked: function () {
      this.$emit('itemClicked')
    }
  },
  mounted: function () {
    if (this.currentRouteName === 'Account' || this.currentRouteName === 'Projekte' || this.currentRouteName === 'Timeline') {
      this.configMenu = false
      this.profileMenu = true
    } else {
      this.configMenu = true
      this.profileMenu = false
    }
  },
  watch: {
    currentRouteName: function (val) {
      if (val === 'Account' || val === 'Projekte' || val === 'Timeline') {
        this.configMenu = false
        this.profileMenu = true
      } else {
        this.configMenu = true
        this.profileMenu = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";
#app-drawer {
  background: #FCFCFC;
  height: calc(100% - 80px);
  position: fixed;
  overflow: auto;
  overflow-x:hidden;
  overflow-y:auto;
  -webkit-overflow-scrolling: touch;
  top:80px;
  padding: 20px 0;
  width:240px;
  margin-left:-240px;
  z-index: 98;
  transition: margin 0.2s ease-in-out;
}
.expanded-small-overview #app-drawer {
  margin-left:0;
}
#overview-nav {
  user-select: none;
  ul {
    border-top: 1px solid transparent;
    .sub-menu-toggle {
      display: flex;
      align-items: center;
      padding: 12px 13px 10px 14px;
      font-family: $primaryFont;
      font-weight: $primaryFontBold;
      margin: 0;
      a {
        color: $primaryFontColor;
        text-decoration: none;
      }
      img {
        width: 26px;
        height: 26px;
        margin-right: 8px;
        border-radius: 6px;
      }
      &:hover {
        background:#f0f0f0;
        cursor: pointer;
      }
    }
    ul {
      border:none;
      li {
        a {
          padding: 6px 13px 6px 17px;
          position: relative;
          overflow: hidden;
          color: $secondaryFontColor;
          text-decoration: none;
          &:hover {
            background:#f0f0f0;
          }
          &:before {
            content:'';
            width: 8px;
            height: 8px;
            background: $secondaryFontColor;
            border-radius: 4px;
            margin-right: 12px;
            display: block;
          }
        }
      }
    }
  }
  .active-menu {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    background: #f7f7f7;
    margin-bottom: 10px;
  }
}
.logout-button {
  @include backend-button();
  width: 100%;
}
#overview-nav ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
#overview-nav li {
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 600;
}
#overview-nav li a,
#overview-nav li a:hover,
#overview-nav li a:focus,
#overview-nav li a:visited,
#overview-nav li a:active {

}
#overview-nav li a.router-link-exact-active,
#overview-nav li a.router-link-exact-active:hover,
#overview-nav li a.router-link-exact-active:focus,
#overview-nav li a.router-link-exact-active:visited,
#overview-nav li a.router-link-exact-active:active {
  color:#1A1A1A;
}
#overview-nav li a:before {

}
#overview-nav li a.router-link-exact-active:before {
  background: #5373FF;
}
#sub-nav {
  margin-top: 10px;
  border-top:1px solid #f0f0f0;
}
#sub-nav ul {
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: center;
  padding: 15px 0 15px 0;
}
#sub-nav ul a {
  font-size: 14px;
  font-weight: 600;
  color: #1A1A1A;
}
#legal-notice {
  text-align: center;
  padding: 0 15px 0 15px;
  font-size: 14px;
  font-weight: 600;
  color: #949494;
  display: block;
  line-height: 1.6;
  margin-bottom: 20px;
}
@media(min-width:400px) {
  #app-drawer {
    margin-left:-250px;
    width:250px;
  }
  #app-drawer {
    /*  height: calc(100% - 90px);
    top:90px; */
  }
  #legal-notice {
    padding: 0 40px 0 40px;
  }
}
@media(min-width:767px) {
  #overview-nav {
    ul {
      .sub-menu-toggle {
        display: flex;
        align-items: center;
        padding: 12px 13px 10px 38px;
        margin: 0;
        img {
          width: 28px;
          height: 28px;
          margin-right: 10px;
        }
      }
      ul {
        padding: 0 0 4px 0;
        li {
          a {
            padding: 6px 38px 6px 42px;
          }
        }
      }
    }
  }
  #app-drawer {
    padding: 20px 0;
    margin-left:-280px;
    width:280px;
  }
}
@media(min-width:1180px) {
  #app-drawer {
    left:280px;
    transition: margin 0s;
  }
  .closed-large-overview #app-drawer {
    display:none;
  }
}
.expand-enter-active, .fexpand-leave-active {
  transition: opacity .2s;
}
.expand-enter, .expand-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
